export interface ClassTypeDbDto {
  ClassTypeDBID: number;
  DBName: string;
  TableEndPoint: string;
  ColumnEndPoint: string;
  bActive: boolean;
}
